export const GET_CRATE_LIST = 'GET_CUSTOMER_CRATE';
export const CLEAR_CRATE_LIST = 'CLEAR_CRATE';
export const DOWNLOAD_CRATE_LIST = 'DOWNLOAD_CRATE';
export const DOWNLOAD_CRATE_FILES = 'DOWNLOAD_CRATE_FILES';